import { AppSharedModule } from 'src/app/shared/shared.module';
import { NgModule } from '@angular/core';
import { WrapperPageComponent } from './wrapper-page.component';


@NgModule({
    imports: [
        AppSharedModule
    ],
    declarations: [
        WrapperPageComponent
    ],
    providers: [

    ],
    exports: [
        WrapperPageComponent
    ]
})
export class WrapperPageModule {

}
